interface ServiceConfig {
  baseURL: string;
  hostname: string[];
}
const configDev: ServiceConfig = {
  // baseURL: 'http://192.168.0.86:8080/'
  baseURL: 'https://xqfx-api-test.unisolution.cn/',
  hostname: ['localhost', 'http://test-xqfx.smart-campus.cn']
};

const configPrd: ServiceConfig = {
  baseURL: 'https://xqfx-api.jyjyapp.com/',
  hostname: ['xqfx.jyjyapp.com']
};

let config = {} as ServiceConfig;
if (configPrd.hostname.includes(location.hostname)) {
  config = configPrd;
} else {
  config = configDev;
}
export default config;
